import styled from 'styled-components'
import ReactPaginate from 'react-paginate'

import Icon from '../Icon'
import { pxToRem } from '../../theme'

export const Container = styled(ReactPaginate)`
  ${({ theme }) => theme.textStyles.d1440_button}
  padding: 0;
  list-style: none;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(16)};
  cursor: pointer;
  & a {
    transition: all 300ms ease-in-out;
  }
  & a:hover:not([aria-disabled='true']) {
    text-decoration: underline;
  }
  & .selected a {
    text-decoration: underline;
    pointer-events: none;
  }
  & a[aria-disabled='true'] {
    opacity: 0.5;
    cursor: default;
  }
  & > .previous {
    margin-inline-end: auto;
  }
  & > .next {
    margin-inline-start: auto;
  }
`
export const Nav = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.small};
  cursor: pointer;
  transition: all 300ms ease-in-out;
  color: rgba(0, 0, 0, 1);
  a:hover:not([aria-disabled='true']) & {
    color: rgba(0, 0, 0, 1);
  }
  a[aria-disabled='true'] & {
    cursor: default;
    color: rgba(0, 0, 0, 0.3);
  }
`
export const NavIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
export const NavPrev = styled(Nav)``
export const NavNext = styled(Nav)``
